module.exports = __webpack_public_path__ + "images/eu_logos_2-972b7db1803c7610b60a077789a4af84.png";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/eu_logos_2.png
// module id = 208
// module chunks = 0